import { extractRoleNamesFromUser } from '@/utils/authUserPayload'
import { getGuardPermissionNamesFromUser } from '@/utils/rbac'

/** 平台超级管理员角色名（与 MainLayout、DefaultSideNav 一致） */
export const SUPER_ADMIN_ROLE_NAMES = ['超级管理员', '平台超管', '平台管理员']

/** 具备平台管理能力时常见的权限名（无角色名匹配时的兜底） */
export const SUPER_ADMIN_PERMISSION_HINTS = ['公司管理', '权限管理']

/**
 * @param {string[]} roleNames
 * @returns {boolean}
 */
export function userHasSuperAdminRole (roleNames) {
  if (!Array.isArray(roleNames) || !roleNames.length) return false
  return roleNames.some((n) => SUPER_ADMIN_ROLE_NAMES.includes(n))
}

/**
 * 综合角色名、权限名、用户载荷上的 is_platform_admin 判断是否为超级管理员
 * @param {{ roleNames?: string[], permissions?: string[], user?: object|null }} ctx
 */
export function resolveIsSuperAdmin ({ roleNames = [], permissions = [], user = null } = {}) {
  if (user && typeof user === 'object') {
    if (user.is_platform_admin === true || user.isPlatformAdmin === true) return true
  }
  if (userHasSuperAdminRole(roleNames)) return true
  if (
    Array.isArray(permissions) &&
    permissions.length &&
    permissions.some((p) => SUPER_ADMIN_PERMISSION_HINTS.includes(p))
  ) {
    return true
  }
  return false
}

/**
 * 从 localStorage.user 判断是否为平台超管（与 MainLayout / 侧栏一致）
 */
export function resolveIsSuperAdminFromStorage () {
  try {
    const raw = localStorage.getItem('user')
    if (!raw) return false
    const user = JSON.parse(raw)
    return resolveIsSuperAdmin({
      user,
      roleNames: extractRoleNamesFromUser(user),
      permissions: getGuardPermissionNamesFromUser(user)
    })
  } catch {
    return false
  }
}
